import React, { useEffect, useRef, useState } from "react";
import { FaTachometerAlt } from "react-icons/fa";

interface PlaybackSpeedProps {
  currentSpeed: number;
  onSpeedChange: (speed: number) => void;
}

const PlaybackSpeed: React.FC<PlaybackSpeedProps> = ({ currentSpeed, onSpeedChange }) => {
  const speeds = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2]; // Added more speeds for scrollable demo
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Close the dropdown if the user clicks outside
  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      {/* Icon Trigger Button */}
      <button
        onClick={() => setShowDropdown(!showDropdown)}
        className="text-white p-2 rounded-full focus:outline-none"
      >
        <FaTachometerAlt className="w-8 h-8"/>
      </button>

      {/* Dropdown Menu (Scrollable for Small Devices) */}
      {showDropdown && (
        <div
          className="absolute bottom-full left-0 mb-2 bg-black border border-gray-700 rounded shadow-lg z-10 max-h-40 overflow-y-auto w-28 sm:max-h-64 scrollbar-thin scrollbar-thumb-gray-700 scrollbar-track-gray-800"
        >
          {speeds.map((rate) => (
            <button
              key={rate}
              onClick={() => {
                onSpeedChange(rate); // Update playback speed
                setShowDropdown(false); // Close dropdown
              }}
              className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-800 ${
                currentSpeed === rate ? "bg-gray-700 text-white" : "text-gray-300"
              }`}
            >
              {rate}x
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default PlaybackSpeed;